import reviewTrustPilotApi from "@/api/reviewTrustPilotApi";
import type { AppDispatch } from "@/redux/store";
import { reviewTrustPilotActions, selectPriceTierTrustPilot } from "@/redux/slice/ReviewTrustPilotSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { reportToFlare } from "@/utils/reportToFlare";

export function useFetchPriceTier() {
  const priceTier = useSelector(selectPriceTierTrustPilot);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    // Check if price tier is already loaded (has tiers array with items)
    if (priceTier?.tiers && priceTier.tiers.length > 0) {
      return;
    }

    reviewTrustPilotApi.getPriceTier()
      .then((payload) => {
        dispatch(reviewTrustPilotActions.setPriceTier(payload));
      })
      .catch((err) => {
        reportToFlare(err, "fetch_price_tier", { type: "trustpilot" });
      });
  }, [dispatch, priceTier]);
}
